import { Box, Typography } from '@mui/material';
import React from 'react';

import { t } from '@/services/translations/config';
import { COLOR } from '@/theme/colors';

const SubscriptionLegend: React.FC = () => {
    return (
        <Box className="bg-sidebarHoverGray">
            <Box
                sx={{
                    py: '32px',
                    px: '20px',
                    mx: 'auto',
                    maxWidth: '1300px',
                    width: '100%',
                }}
            >
                <Box sx={{ maxWidth: '700px' }}>
                    <Typography fontSize={12} color={COLOR.slateGray}>
                        * {t('PremiumPage:legend:firstParagraph')}
                    </Typography>
                    <Typography fontSize={12} mt={1} color={COLOR.slateGray}>
                        ** {t('PremiumPage:legend:secondParagraph')}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default SubscriptionLegend;
